<template>
  <div class="wrapper">
    <div
      :class="`block-signin-member block-signin-member-style2 block-signin-member-${platform}`"
    >
      <div class="block-container">
        <div class="block-images">
          <picture>
            <source media="(max-width: 991px)" :srcset="backgroundMobile" />
            <img :src="backgroundPartner" alt="" width="1500" height="500"/>
          </picture>
        </div>
        <div class="block-detail form" v-show="!isSuccess && !isError">
          <div class="block-form wpcf7-content">
            <div
              class="block-title"
              v-if="platform == 'banmai' || platform == 'lythaito'"
            >
              Đăng ký thẻ thành viên Canifa
            </div>
            <div
              class="block-header"
              v-if="platform != 'banmai' && platform != 'lythaito'"
            >
              <div class="logo">
                <a href="#">
                  <img src="/logo.webp" alt="" width="84" height="44"/>
                </a>
                <span class="line"></span>
                <a href="#">
                  <img :src="logoPartner" alt="" width="84" height="44"/>
                </a>
              </div>
            </div>

            <div class="block-images-mb">
              <picture>
                <source media="(max-width: 991px)" :srcset="backgroundMobile" />
                <img :src="backgroundPartner" alt="" width="600" height="400"/>
              </picture>
            </div>
            <form id="cnf12012022-section-form">
              <div v-if="platform != 'banmai' && platform != 'lythaito'">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Họ</label>
                      <input
                        v-model="firstname"
                        type="text"
                        name="lastname"
                        placeholder="--"
                        class="form-control form-control-lastname"
                        :class="isNameError ? 'error' : ''"
                      />
                      <div v-if="isNameError" class="form-error lastname">
                        Họ của bạn không để trống
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Tên</label>
                      <input
                        v-model="lastname"
                        type="text"
                        name="name"
                        placeholder="--"
                        :class="isLastNameError ? 'error' : ''"
                        class="form-control form-control-name"
                      />
                      <div v-if="isLastNameError" class="form-error name">
                        Tên của bạn không để trống
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Sinh nhật</label>
                      <input
                        v-model="dateofbirth"
                        type="date"
                        name="birthday"
                        placeholder="dd/mm/yyyy"
                        class="form-control form-control-birthday"
                        :class="isDobError ? 'error' : ''"
                      />
                      <div v-if="isDobError" class="form-error birthday">
                        Ngày sinh của bạn không để trống
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Giới tính</label>
                      <select
                        class="form-control form-control-gender"
                        :class="isGennerError ? 'error' : ''"
                        v-model="gender"
                        name="gender"
                      >
                        <option value="">- Chọn -</option>
                        <option value="male">Nam</option>
                        <option value="female">Nữ</option>
                      </select>
                      <div class="form-error gender" v-if="isGennerError">
                        Bạn chưa chọn giới tính của mình
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Số điện thoại</label>
                    <input
                      v-model="phone"
                      type="number"
                      name="phone"
                      :class="isPhoneError ? 'error' : ''"
                      placeholder="Nhập số điện thoại"
                      class="form-control form-control-phone"
                    />
                    <div
                      class="form-error note"
                      v-if="isPhoneError && platform == 'vpbank'"
                    >
                      * Nhập số điện thoại đã đăng ký với VPBank
                    </div>
                    <div
                      class="form-error note"
                      v-if="isPhoneError && platform == 'bamboo'"
                    >
                      * Nhập số điện thoại không để trống
                    </div>
                    <div
                      class="form-error note"
                      v-if="isPhoneError && platform == 'fpt'"
                    >
                      * Nhập số điện thoại đã đăng ký với FPT
                    </div>
                    <div
                      class="form-error note"
                      v-if="isPhoneError && platform == 'banmai'"
                    >
                      * Nhập số điện thoại
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group" v-if="platform != 'fpt'">
                    <label>Email</label>
                    <input
                      v-model="email"
                      type="text"
                      name="email"
                      placeholder="Nhập email"
                      class="form-control form-control-email"
                    />
                    <div class="form-error note" v-if="isEmailError">
                      Email của bạn không để trống
                    </div>
                  </div>
                  <div class="form-group" v-if="platform == 'fpt'">
                    <label>Email FPT</label>
                    <input
                      v-model="email"
                      type="text"
                      name="email"
                      placeholder="Nhập email"
                      class="form-control form-control-email"
                    />
                    <div class="form-error note" v-if="isEmailError">
                      Email của bạn không để trống
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="platform == 'banmai'">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Họ và tên:</label>
                      <input
                        v-model="firstname"
                        type="text"
                        name="lastname"
                        placeholder="--"
                        class="form-control form-control-lastname"
                        :class="isNameError ? 'error' : ''"
                      />
                      <div v-if="isNameError" class="form-error lastname">
                        Tên của bạn không để trống
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Giới tính</label>
                      <select
                        class="form-control form-control-gender"
                        :class="isGennerError ? 'error' : ''"
                        v-model="gender"
                        name="gender"
                      >
                        <option value="">- Chọn -</option>
                        <option value="male">Nam</option>
                        <option value="female">Nữ</option>
                      </select>
                      <div class="form-error gender" v-if="isGennerError">
                        Bạn chưa chọn giới tính của mình
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Ngày/ tháng/ năm sinh:</label>
                      <input
                        v-model="dateofbirth"
                        type="date"
                        name="birthday"
                        placeholder="dd/mm/yyyy"
                        class="form-control form-control-birthday"
                        :class="isDobError ? 'error' : ''"
                      />
                      <div v-if="isDobError" class="form-error birthday">
                        Ngày sinh của bạn không để trống
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Số điện thoại</label>
                      <input
                        v-model="phone"
                        type="number"
                        name="phone"
                        :class="isPhoneError ? 'error' : ''"
                        placeholder="Nhập số điện thoại"
                        class="form-control form-control-phone"
                      />
                      <div
                        class="form-error note"
                        v-if="isPhoneError && platform == 'banmai'"
                      >
                        * Nhập số điện thoại
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Trường/ Đơn vị</label>

                    <input
                      v-model="school"
                      type="text"
                      name="school"
                      :class="isSchoolError ? 'error' : ''"
                      placeholder="Nhập tên trường tại đây"
                      class="form-control form-control-school"
                    />

                    <div v-if="isSchoolError" class="form-error name">
                      Nhập Trường/ Đơn vị
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="platform == 'lythaito'">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Họ và tên Cha mẹ học sinh</label>
                      <input
                        v-model="firstname"
                        type="text"
                        name="lastname"
                        placeholder="--"
                        class="form-control form-control-lastname"
                        :class="isNameError ? 'error' : ''"
                      />
                      <div v-if="isNameError" class="form-error lastname">
                        Tên của bạn không để trống
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Giới tính</label>
                      <select
                        class="form-control form-control-gender"
                        :class="isGennerError ? 'error' : ''"
                        v-model="gender"
                        name="gender"
                      >
                        <option value="">- Chọn -</option>
                        <option value="male">Nam</option>
                        <option value="female">Nữ</option>
                      </select>
                      <div class="form-error gender" v-if="isGennerError">
                        Bạn chưa chọn giới tính của mình
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Ngày/ tháng/ năm sinh CMHS</label>
                      <input
                        v-model="dateofbirth"
                        type="date"
                        name="birthday"
                        placeholder="dd/mm/yyyy"
                        class="form-control form-control-birthday"
                        :class="isDobError ? 'error' : ''"
                      />
                      <div v-if="isDobError" class="form-error birthday">
                        Ngày sinh của bạn không để trống
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Số điện thoại</label>
                      <input
                        v-model="phone"
                        type="number"
                        name="phone"
                        :class="isPhoneError ? 'error' : ''"
                        placeholder="Nhập số điện thoại"
                        class="form-control form-control-phone"
                      />
                      <div
                        class="form-error note"
                        v-if="isPhoneError && platform == 'banmai'"
                      >
                        * Nhập số điện thoại
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Là Cha mẹ học sinh</label>
                      <input
                        v-model="student"
                        type="text"
                        name="student"
                        placeholder="Họ và Tên học sinh"
                        :class="isStudentError ? 'error' : ''"
                        class="form-control form-control-name"
                      />
                      <div v-if="isStudentError" class="form-error name">
                        Tên không để trống
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Học sinh trường</label>

                      <label>
                        <input
                          type="radio"
                          name="school"
                          value="Trường mầm non Lý Thái Tổ"
                          checked
                          v-model="school"
                        />
                        <span>Trường mầm non Lý Thái Tổ</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="school"
                          value="Trường tiểu học Lý Thái Tổ"
                          v-model="school"
                        />
                        <span>Trường tiểu học Lý Thái Tổ</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="school"
                          value="Trường THCS - THPT Lý Thái Tổ"
                          v-model="school"
                        />
                        <span>Trường THCS - THPT Lý Thái Tổ</span>
                      </label>

                      <div v-if="isSchoolError" class="form-error name">
                        Bạn chưa chọn trường học
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group form-captra">
                    <div class="g-recaptcha" id="gcapcha"></div>
                    <div class="form-error note" v-if="isCapcha">
                      * Vui lòng ấn vào reCAPTCHA
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-actions" v-if="platform != 'fpt'">
                <input
                  type="button"
                  value="Đăng ký"
                  @click="signup"
                  class="btn form-control-submit"
                />
              </div>
              <div class="form-actions" v-if="platform == 'fpt'">
                <input
                  type="button"
                  value="Nhận mã"
                  @click="signup"
                  class="btn form-control-submit"
                />
              </div>
            </form>
          </div>
        </div>
        <div class="wpcf7-response-loading" v-if="isLoading">
          <div class="loader"></div>
        </div>
        <div class="wpcf7-response-error" v-if="isError">
          <div class="box">
            <div class="box-content">
              <span class="box-close"></span>
              <h1>Có lỗi xảy ra, mời bạn thử lại.</h1>
            </div>
          </div>
        </div>
        <div
          class="block-detail-successful wpcf7-response-output"
          v-show="isSuccess && !isError"
        >
          <div class="content">
            <div class="icon">
              <svg
                width="81"
                height="80"
                viewBox="0 0 81 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M40.5 12.5C25.3122 12.5 13 24.8122 13 40C13 55.1878 25.3122 67.5 40.5 67.5C55.6878 67.5 68 55.1878 68 40C68 24.8122 55.6878 12.5 40.5 12.5ZM8 40C8 22.0507 22.5507 7.5 40.5 7.5C58.4493 7.5 73 22.0507 73 40C73 57.9493 58.4493 72.5 40.5 72.5C22.5507 72.5 8 57.9493 8 40Z"
                  fill="#37AD56"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M56.4756 28.2743C57.4287 29.2733 57.3914 30.8558 56.3924 31.8089L38.0487 49.3089C37.0822 50.2309 35.5615 50.2303 34.5958 49.3074L25.4395 40.5574C24.4413 39.6035 24.4054 38.021 25.3593 37.0228C26.3133 36.0246 27.8958 35.9887 28.894 36.9426L36.3245 44.0434L52.9411 28.1911C53.9401 27.2381 55.5226 27.2753 56.4756 28.2743Z"
                  fill="#37AD56"
                />
              </svg>
            </div>
            <div v-if="platform == 'vpbank'">
              <h1>Đăng ký thành công!</h1>
              <p>
                Chúc mừng quý khách đã gửi yêu cầu đăng kí phiên ngang hạng thẻ
                thành công. Quá trình phiên ngang hạng thẻ sẽ được hoàn thành
                trong vòng 7 ngày làm việc. Quý khách vui lòng kiểm tra email để
                đăng nhập tài khoản trên App và nhận ưu đãi dành cho hội viên
                mới.
              </p>
            </div>
            <div v-if="platform == 'bamboo'">
              <h1>Đăng ký thành công!</h1>
              <p>
                Chúc mừng quý khách đã gửi yêu cầu đăng kí phiên ngang hạng thẻ
                thành công. Qúa trình phiên ngang hạng thẻ sẽ được hoàn thành
                trong vòng 7 ngày làm việc. Quý khách vui lòng kiểm tra tin nhắn
                SMS để đăng nhập tài khoản trên App và nhận ưu đãi dành cho hội
                viên mới.
              </p>
            </div>

            <div v-if="platform == 'fpt'">
              <h1>Đăng ký thành công!</h1>
              <p>
                Chúc mừng quý khách đã gửi yêu cầu đăng kí nhận mã thành công.
                Quá trình gửi mã sẽ được hoàn thành trong vòng 1 ngày làm việc.
                Quý khách vui lòng kiểm tra email nhận ưu đãi 35% cho sản phẩm
                nguyên giá tại Canifa.
              </p>
            </div>

            <div v-if="platform == 'vietinbank'">
              <h1>Đăng ký thành công!</h1>
              <p>
                Chúc mừng quý khách đã gửi yêu cầu đăng kí nhận mã thành công.
                Quá trình gửi mã sẽ được hoàn thành trong vòng 1 ngày làm việc.
                Quý khách vui lòng kiểm tra email nhận ưu đãi cho sản phẩm
                nguyên giá tại Canifa.
              </p>
            </div>

            <div v-if="platform == 'banmai'">
              <h1 style="font-size: 16px">
                Chúc mừng Quý Cha mẹ học sinh đã đăng ký thành công! <br />Quý
                Cha mẹ vui lòng truy cập App Canifa để kiểm tra thông tin.
              </h1>
              <p>
                Sau ngày 31/8/2024, hạng thẻ của Quý Cha mẹ sẽ được nâng hạng
                Diamond và được hưởng ưu đãi giảm giá 15% theo chính sách Canifa
                trong vòng 12 tháng kể từ ngày kích hoạt.
              </p>
              <p>
                <button class="btn btn-inline" @click="close">Đóng</button>
              </p>
            </div>

            <div v-if="platform == 'lythaito'">
              <h1 style="font-size: 16px">
                Chúc mừng Quý Cha mẹ học sinh đã đăng ký thành công! <br />Quý
                Cha mẹ vui lòng truy cập App Canifa để kiểm tra thông tin.
              </h1>
              <p>
                Sau ngày 05/09/2025, hạng thẻ của Quý Cha mẹ sẽ được nâng hạng Diamond và được hưởng ưu đãi giảm giá 15% theo chính sách Canifa trong vòng 12 tháng kể từ ngày kích hoạt.
              </p>
              <p>
                <button class="btn btn-inline" @click="close">Đóng</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onBeforeMount,
  useRoute,
  useRouter,
} from "@nuxtjs/composition-api";
import moment from "moment";
import axios from "axios";
import api from "~/config/extensionsApi";

export default defineComponent({
  name: "MemberShip",
  layout: "empty",
  components: {},
  setup() {
    const route = useRoute();
    const router = useRouter();

    const breadcrumbs = ref([
      {
        text: "Home",
        route: {
          link: "/",
        },
      },
      {
        text: "Check your order",
        route: {
          link: "/tra-don-hang",
        },
      },
    ]);
    const inputChecking = ref(null);
    const key = api.recapcha.key_recaptcha;
    const order = ref(null);
    const orderInfor = ref([]);
    const isCheckCapcha = ref(false);
    const firstname = ref(null);
    const lastname = ref(null);
    const student = ref(null);
    const school = ref(null);
    const dateofbirth = ref(null);
    const gender = ref(null);
    const phone = ref(null);
    const email = ref(null);
    const isEmailError = ref(false);
    const isNameError = ref(false);
    const isLastNameError = ref(false);
    const isDobError = ref(false);
    const isGennerError = ref(false);
    const isPhoneError = ref(false);
    const isStudentError = ref(false);
    const isSchoolError = ref(false);
    const isSuccess = ref(false);
    const partner = ref("bamboo");
    const logoPartner = ref("");
    const backgroundPartner = ref("");
    const backgroundMobile = ref("");
    const isLoading = ref(false);
    const isError = ref(false);
    const isCapcha = ref(false);
    const platform = computed(() => {
      return route.value?.query?.platform || null;
    });
    const listPlatForm = ref([
      "bamboo",
      "vpbank",
      "fpt",
      "vietinbank",
      "banmai",
      "lythaito",
    ]);

    // Methods
    const validateEmail = (email) => {
      const emailRegex =
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      return emailRegex.test(email);
    };

    const recaptchaCallback = () => {
      isCheckCapcha.value = true;
    };

    const checkValidate = () => {
      if (firstname.value && firstname.value?.length > 0) {
        isNameError.value = false;
      } else {
        isNameError.value = true;
      }
      if (lastname.value && lastname.value?.length > 0) {
        isLastNameError.value = false;
      } else {
        isLastNameError.value = true;
      }
      if (student.value && student.value?.length > 0) {
        isStudentError.value = false;
      } else {
        isStudentError.value = true;
      }
      if (school.value && school.value?.length > 0) {
        isSchoolError.value = false;
      } else {
        isSchoolError.value = true;
      }
      if (dateofbirth.value && dateofbirth.value?.length > 0) {
        isDobError.value = false;
      } else {
        isDobError.value = true;
      }
      if (phone.value && phone.value?.length == 10) {
        isPhoneError.value = false;
      } else {
        isPhoneError.value = true;
      }
      if (gender.value && gender.value?.length > 0) {
        isGennerError.value = false;
      } else {
        isGennerError.value = true;
      }
      if (!email.value || email.value?.length == 0) {
        isEmailError.value = true;
      } else {
        if (email.value && validateEmail(email.value)) {
          isEmailError.value = false;
        } else {
          isEmailError.value = true;
        }
      }
    };

    const checkPlastForm = () => {
      if (
        !platform.value ||
        !listPlatForm.value?.find((e) => e == platform.value)
      ) {
        router.push("/");
      }

      if (platform.value) {
        partner.value = platform.value;
        logoPartner.value = `/membership/${partner.value}_logo.webp`;
        backgroundPartner.value = `/membership/${partner.value}_background.webp`;
        backgroundMobile.value = `/membership/${partner.value}_background_mb.webp`;
        return;
      }

      logoPartner.value = `/membership/${partner.value}_logo.webp`;
      backgroundPartner.value = `/membership/${partner.value}_background.webp`;
      backgroundMobile.value = `/membership/${partner.value}_background_mb.webp`;
    };

    const convertDate = (dateCreated) => {
      const date = new Date(dateCreated);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const createdDate = () => {
      const today = new Date();
      const day = today.getDate().toString().padStart(2, "0");
      const month = (today.getMonth() + 1).toString().padStart(2, "0");
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const partnerOdoo = async (data) => {
      await axios.post(api.customer.customer_create_pre_res_partner, data);
    };

    const googleSheets = async () => {
      isLoading.value = true;
      const params = {
        name: firstname.value,
        phone: phone.value,
        gender: gender.value == "female" ? "Nữ" : "Nam",
        birthday: convertDate(dateofbirth.value),
        lastname: lastname.value,
        email: email.value ? email.value : "",
        date: createdDate(),
        student: student.value,
        school: school.value,
      };

      let queryString = "";
      for (let key in params) {
        queryString += `${encodeURIComponent(key)}=${encodeURIComponent(
          params[key]
        )}&`;
      }

      let url = "";

      if (platform.value == "vpbank") {
        url = `https://script.google.com/macros/s/AKfycbx2jeUFl9JozOIj5q-OTXdMLsYb2cKVCDVSa1sco0sGkNCOvJ9vgwG_rmMopj60FeJT_w/exec?${queryString}`;
      } else if (platform.value == "fpt") {
        url = `https://script.google.com/macros/s/AKfycbyyCsbY5ytbh1IJ8lL_gsoUXd52zbN_u1tEJUCzNVPUv3J0kHA04iioht3veyMm_srJ/exec?${queryString}`;
      } else if (platform.value == "vietinbank") {
        url = `https://script.google.com/macros/s/AKfycbySK7F0VwAD2AJzK6c-deiMzcykFQzEz8y41NBXAOI9xPYuKG1ZliKzQ21h2aRZDXhi/exec?${queryString}`;
      } else if (platform.value == "banmai") {
        url = `https://script.google.com/macros/s/AKfycbztoZ-HMCDq1XYBa_7TrYOsXB9PETE8c1Q6Y0lAnJ_sT7-gZ01LsnuVyVz6ODIKO7BE/exec?${queryString}`;
      } else if (platform.value == "lythaito") {
        url = `https://script.google.com/macros/s/AKfycbw01biVtpertXjpr3yrusYvBd9G6y_dxJAGVGZgFeaVDhv6_OpKL7YA2_LpKFwUCvFjZA/exec?${queryString}`;
      }

      axios
        .get(url)
        .then((response) => {
          isLoading.value = false;
          if (response.data?.result == "success") {
            isSuccess.value = true;
          } else {
            isError.value = true;
          }
        })
        .catch((error) => {
          isLoading.value = false;
          isError.value = true;
          console.error(error);
        });
    };

    const signup = async () => {
      checkValidate();

      if (platform.value == "lythaito") {
        if (
          isNameError.value ||
          isDobError.value ||
          isGennerError.value ||
          isPhoneError.value ||
          isStudentError.value ||
          isSchoolError.value
        ) {
          return;
        }
      } else if (platform.value == "banmai") {
        if (
          isNameError.value ||
          isDobError.value ||
          isGennerError.value ||
          isPhoneError.value ||
          isSchoolError.value
        ) {
          return;
        }
      } else {
        if (
          isNameError.value ||
          isLastNameError.value ||
          isDobError.value ||
          isGennerError.value ||
          isPhoneError.value ||
          isEmailError.value
        ) {
          return;
        }
      }

      if (!isCheckCapcha.value) {
        isCapcha.value = true;
        return;
      } else {
        isCapcha.value = false;
      }

      let data = {
        partner: partner.value,
        name: firstname.value + " " + lastname.value,
        date_create: moment(new Date()).format("YYYY-MM-DD"),
        phone: phone.value,
        birthday: dateofbirth.value,
        type_card: "Green",
        email: email.value,
        gender: gender.value,
        tudent: student.value,
        school: school.value,
      };

      if (platform.value == "bamboo") {
        try {
          isLoading.value = true;
          let result = await axios.post(api.erp.create_account_partner, data);
          if (result?.data?.result?.status_code == 200) {
            isSuccess.value = true;
            isLoading.value = false;
          } else {
            isLoading.value = false;
            isError.value = true;
            alert(result?.data?.result?.message);
          }
        } catch (error) {
          isLoading.value = false;
          isError.value = true;
        }
      } else if (platform.value == "vpbank") {
        let dataOdoo = {
          jsonrpc: "2.0",
          params: {
            data: {
              firstname: firstname.value,
              lastname: lastname.value,
              dob: moment(dateofbirth.value).format("YYYY/MM/DD"),
              gender: gender.value,
              phone_num: phone.value,
              email: email.value,
              input_date: moment(new Date()).format("YYYY/MM/DD"),
              bank_name: "Vpbank",
            },
          },
        };
        googleSheets();
        partnerOdoo(dataOdoo);
      } else if (platform.value == "fpt") {
        googleSheets();
        let dataOdoo = {
          jsonrpc: "2.0",
          params: {
            data: {
              firstname: firstname.value,
              lastname: lastname.value,
              dob: moment(dateofbirth.value).format("YYYY/MM/DD"),
              gender: gender.value,
              phone_num: phone.value,
              email: email.value,
              input_date: moment(new Date()).format("YYYY/MM/DD"),
              bank_name: "Vietinbank",
            },
          },
        };
        partnerOdoo(dataOdoo);
      } else if (platform.value == "vietinbank") {
        googleSheets();
        let dataOdoo = {
          jsonrpc: "2.0",
          params: {
            data: {
              firstname: firstname.value,
              lastname: lastname.value,
              dob: moment(dateofbirth.value).format("YYYY/MM/DD"),
              gender: gender.value,
              phone_num: phone.value,
              email: email.value,
              input_date: moment(new Date()).format("YYYY/MM/DD"),
              bank_name: "Vietinbank",
            },
          },
        };
        partnerOdoo(dataOdoo);
      } else if (platform.value == "banmai") {
        let dataOdoo = {
          jsonrpc: "2.0",
          params: {
            data: {
              lastname: lastname.value,
              dob: moment(dateofbirth.value).format("YYYY/MM/DD"),
              gender: gender.value,
              phone_num: phone.value,
              school: school.value,
              input_date: moment(new Date()).format("YYYY/MM/DD"),
              bank_name: "banmai",
            },
          },
        };
        partnerOdoo(dataOdoo);
        googleSheets();
      } else if (platform.value == "lythaito") {
        let dataOdoo = {
          jsonrpc: "2.0",
          params: {
            data: {
              lastname: lastname.value,
              dob: moment(dateofbirth.value).format("YYYY/MM/DD"),
              gender: gender.value,
              phone_num: phone.value,
              tudent: student.value,
              school: school.value,
              input_date: moment(new Date()).format("YYYY/MM/DD"),
              bank_name: "lythaito",
            },
          },
        };
        partnerOdoo(dataOdoo);
        googleSheets();
      }
    };

    const close = () => {
      isSuccess.value = false;
      isError.value = false;

      firstname.value = null;
      lastname.value = null;
      student.value = null;
      school.value = null;
      dateofbirth.value = null;
      phone.value = null;
      gender.value = null;
      email.value = null;

      isEmailError.value = false;
      isNameError.value = false;
      isLastNameError.value = false;
      isDobError.value = false;
      isGennerError.value = false;
      isPhoneError.value = false;
      isStudentError.value = false;
      isSchoolError.value = false;
    };

    // Watchers
    watch(firstname, (newVal) => {
      if (newVal && newVal.length > 0) {
        isNameError.value = false;
      } else {
        isNameError.value = true;
      }
    });

    watch(lastname, (newVal) => {
      if (newVal && newVal.length > 0) {
        isLastNameError.value = false;
      } else {
        isLastNameError.value = true;
      }
    });

    watch(student, (newVal) => {
      if (newVal && newVal.length > 0) {
        isStudentError.value = false;
      } else {
        isStudentError.value = true;
      }
    });

    watch(school, (newVal) => {
      if (newVal && newVal.length > 0) {
        isSchoolError.value = false;
      } else {
        isSchoolError.value = true;
      }
    });

    watch(dateofbirth, (newVal) => {
      if (newVal && newVal.length > 0) {
        isDobError.value = false;
      } else {
        isDobError.value = true;
      }
    });

    watch(phone, (newVal) => {
      if (newVal && newVal.length == 10) {
        isPhoneError.value = false;
      } else {
        isPhoneError.value = true;
      }
    });

    watch(gender, (newVal) => {
      if (newVal && newVal.length > 0) {
        isGennerError.value = false;
      } else {
        isGennerError.value = true;
      }
    });

    watch(email, (newVal) => {
      if (newVal && validateEmail(newVal)) {
        isEmailError.value = false;
      } else {
        isEmailError.value = true;
      }
    });

    // Lifecycle hooks
    onBeforeMount(() => {
      let recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js"
      );
      document.head.appendChild(recaptchaScript);

      let recaptchagoogleScript = document.createElement("script");
      recaptchagoogleScript.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit"
      );
      document.head.appendChild(recaptchagoogleScript);
    });

    onMounted(() => {
      setTimeout(() => {
        checkPlastForm();

        var script = document.createElement("script");
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
        script.async = true;
        document.head.appendChild(script);

        const vm = {
          isCheckCapcha,
          key,
        };

        var verifyCallback = function (response) {
          vm.isCheckCapcha.value = true;
        };

        var onloadCallback = function () {
          window.grecaptcha.render("gcapcha", {
            sitekey: vm.key,
            callback: verifyCallback,
          });
        };

        onloadCallback();
      }, 1500);
    });

    return {
      breadcrumbs,
      inputChecking,
      key,
      order,
      orderInfor,
      isCheckCapcha,
      firstname,
      lastname,
      student,
      school,
      dateofbirth,
      gender,
      phone,
      email,
      isEmailError,
      isNameError,
      isLastNameError,
      isDobError,
      isGennerError,
      isPhoneError,
      isStudentError,
      isSchoolError,
      isSuccess,
      partner,
      logoPartner,
      backgroundPartner,
      backgroundMobile,
      isLoading,
      isError,
      isCapcha,
      platform,
      listPlatForm,
      validateEmail,
      recaptchaCallback,
      checkValidate,
      checkPlastForm,
      convertDate,
      createdDate,
      partnerOdoo,
      googleSheets,
      signup,
      close,
    };
  },
});
</script>

<style scoped>
.pt-10 {
  padding-top: 10px;
  color: red !important;
}
</style>

<style scoped>
@import url("~assets/css/page-member.css");
</style>
